export enum EPresetType {
  AddForm = 'AddForm',
  NewAddForm = 'NewAddForm',
  NewAddFormEarlyPublish = 'NewAddFormEarlyPublish',
  MyOffers = 'MyOffers',
}
